
import React, { useState } from "react";
import ModeSelector from "../modes/ModeSelector";

interface CalculatorFrameworkProps {
  children: (props: {
    currentStep: number;
    setCurrentStep: (step: number) => void;
    mode: "fast" | "tutorial" | null;
    setMode: (mode: "fast" | "tutorial" | null) => void;
    handleBackToModeSelection: () => void;
  }) => React.ReactNode;
}

const CalculatorFramework = ({ children }: CalculatorFrameworkProps) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [mode, setMode] = useState<"fast" | "tutorial" | null>(null);

  const handleBackToModeSelection = () => {
    setCurrentStep(1);
    setMode(null);
  };

  const goToTutorial = () => {
    setMode("tutorial");
    setCurrentStep(1);
  };

  return (
    <div className="space-y-4">
      {/* Step 1: Mode Selection */}
      {currentStep === 1 && mode === null && (
        <ModeSelector
          onSelectFastMode={() => setMode("fast")}
          onSelectTutorialMode={goToTutorial}
        />
      )}

      {/* Render calculator-specific content */}
      {children({
        currentStep,
        setCurrentStep,
        mode,
        setMode,
        handleBackToModeSelection
      })}
    </div>
  );
};

export default CalculatorFramework;
